export const PERMISSIONS = Object.freeze({
  ANDROID: {},
  IOS: {},
  WINDOWS: {}
});
//# sourceMappingURL=permissions.js.map